import type { RestaurantDetails } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getRestaurantDetails as getRestaurantDetailsQuery } from "@/graphql/queries";

const client = generateClient();

export const restaurantToCompareState = create<State<RestaurantDetails>>(
  () => ({
    data: null,
    isLoading: false,
    error: null,
    isFetching: false,
  }),
);

export const getRestaurantToCompareIsloading = () =>
  restaurantToCompareState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getRestaurantToCompareIsError = (error: Error) =>
  restaurantToCompareState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getRestaurantToCompareIsSuccess = (
  restaurantDetails: RestaurantDetails,
) =>
  restaurantToCompareState.setState(() => ({
    data: restaurantDetails,
    isLoading: false,
    error: null,
  }));

export const resetRestaurantToCompare = () =>
  restaurantToCompareState.setState(() =>
    restaurantToCompareState.getInitialState(),
  );

export type getRestaurantToCompareParams = {
  id: string;
};

export const getRestaurantToCompare = async ({
  id,
}: getRestaurantToCompareParams) => {
  getRestaurantToCompareIsloading();

  try {
    const { data } = await client.graphql({
      query: getRestaurantDetailsQuery,
      variables: {
        id,
      },
    });

    getRestaurantToCompareIsSuccess(
      data.getRestaurantDetails as RestaurantDetails,
    );
  } catch (e) {
    const errorMessage =
      e instanceof Error
        ? e.message
        : "failed to query get restaurant to compare";
    getRestaurantToCompareIsError(Error(errorMessage));
  }
};
